module.exports = __webpack_public_path__ + "img/logo_navbar.ec5cddea.png";